import React, { memo } from "react";
import IndicadorProvider from "../../contexts/IndicadoresContext";
import IndicadorOverview from "./IndicadorOverview";

const Indicador = memo(() => {
  return (
    <IndicadorProvider>
      <IndicadorOverview />
    </IndicadorProvider>
  );
});

Indicador.displayName = "Indicador";

export default Indicador;
